export const defaultTitle = {
    '@type': '@builder.io/sdk:Element',
    layerName: 'Accordion Title',
    responsiveStyles: {
        large: {
            marginTop: '10px',
            position: 'relative',
            display: 'flex',
            alignItems: 'stretch',
            paddingTop: '10px',
            paddingBottom: '10px'
        }
    },
    component: {
        name: 'AccordionTitle',
        options: {
            content: [
                {
                    '@type': '@builder.io/sdk:Element',
                    responsiveStyles: {
                        large: {
                            textAlign: 'left',
                            display: 'flex'
                        }
                    },
                    component: {
                        name: 'Text',
                        options: {
                            text: 'I am an accordion title. Click me!'
                        }
                    }
                }
            ]
        }
    }
}

export const defaultDetail = {
    '@type': '@builder.io/sdk:Element',
    layerName: 'Accordion Detail',
    responsiveStyles: {
        large: {
            marginTop: '10px',
            position: 'relative',
            display: 'flex',
            alignItems: 'stretch',
            flexDirection: 'column',
            paddingTop: '10px',
            paddingBottom: '10px'
        }
    },
    component: {
        name: 'AccordionDetail',
        options: {
            content: [
                {
                    '@type': '@builder.io/sdk:Element',
                    responsiveStyles: {
                        large: {
                            textAlign: 'left',
                            display: 'flex',
                            flexDirection: 'column'
                        }
                    },
                    component: {
                        name: 'Text',
                        options: {
                            text: 'I am accordion content!!!'
                        }
                    }
                }
            ]
        }
    }
}

export const defaultItem = {
    '@type': '@builder.io/sdk:Element',
    layerName: 'Accordion Item',
    responsiveStyles: {
        large: {
            marginTop: '10px',
            position: 'relative',
            display: 'flex',
            alignItems: 'stretch',
            flexDirection: 'column'
        }
    },
    component: {
        name: 'AccordionItem',
        options: {
            content: [defaultTitle, defaultDetail]
        }
    }
}
